/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/WorkItemIcon" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { getLinkedWorkItemsService } from "Wit/LinkedWorkItemsDropdown/LinkedWorkItemsService";
import { WorkItemTypeIconProvider } from "Wit/UI/Data";
import { WorkItemTypeIcon } from "Wit/UI/WorkItemTypeIcon";
import { IWorkItemIconProps } from "./ControlledLinkedWorkItemsDropdown.Props";

export class WorkItemIcon extends VssComponent<IWorkItemIconProps> {
    public render() {
        const { workItem } = this.props;

        return (
            <WorkItemTypeIconProvider
                dataProvider={getLinkedWorkItemsService(this.context.pageContext).getDataProvider()}
                dataSource={{
                    projectIdOrName: workItem.fields[CoreFieldRefNames.TeamProject],
                    workItemTypeName: workItem.fields[CoreFieldRefNames.WorkItemType]
                }}
            >
                {icon => (
                    <span className="padding-right-8">
                        <WorkItemTypeIcon data={icon} />
                    </span>
                )}
            </WorkItemTypeIconProvider>
        );
    }
}
